const yeText = '月嫂'
export const STAR_STANDARD_TXT_MAP = new Map([
  [4, `金牌${yeText}`],
  [3, `五星${yeText}`],
  [2, `四星${yeText}`],
  [1, `三星${yeText}`]
])

// 线索品类
// 月嫂 ,产后恢复, 月子中心, 宝宝纪念品, 小儿理发, 早教, 儿童摄影,才艺运动
export const CLUE_CATEGORY = {
  YUESAO: '月嫂',
  POSTPARTUM_RECOVERY: '产后恢复',
  YUEZI_CENTER: '月子中心',
  BABY_SOUVENIR: '宝宝纪念品',
  KID_HAIRCUT: '小儿理发',
  EARLY_EDUCATION: '早教',
  KID_PHOTO: '儿童摄影',
  TALENT_SPORT: '才艺运动'
}
// 线索来源
// 1-心愿单 2-预约月嫂 3-员工推荐 4-地推  5-商户券 6-平台券 7-自动收集 8-其他
export const CLUE_SOURE = {
  // WANTED: '心愿单',
  // ORDER_YUESAO: '预约月嫂',
  // EMPLOYEE_RECOMMENDATION: '员工推荐',
  // GROUND_PUSH: '地推',
  // BUSINESS_COUPONS: '商户券',
  // PLATFORM_COUPONS: '平台券',
  // AUTO_COLLECTION: '自动收集',
  // OTHER: '其他',
  WANTED: 1,
  ORDER_YUESAO: 2,
  EMPLOYEE_RECOMMENDATION: 3,
  GROUND_PUSH: 4,
  BUSINESS_COUPONS: 5,
  PLATFORM_COUPONS: 6,
  AUTO_COLLECTION: 7,
  OTHER: 8
}
